import { Empty, Spin } from "antd";
import { useSelector } from "react-redux";
import type { Note, NotesState } from "@store/reducers/notes.reducer";
import { NoteCard } from "./NoteCard";

interface NotesListProps {
    /** The notes that pass the filters, newest first. */
    notes: Note[];
    /** The number of loaded notes before the filters. It tells an empty range from an empty filter result. */
    totalCount: number;
    loading: boolean;
    onDelete: (note: Note) => Promise<void>;
    onEdit?: (note: Note) => void;
    /** False on a Player page, where every note is about the same player. */
    showPlayer: boolean;
    /** Lays the cards out in two columns, newest first across each row. */
    twoColumns: boolean;
}

export const NotesList = ({ notes, totalCount, loading, onDelete, onEdit, showPlayer, twoColumns }: NotesListProps) => {
    const attributes = useSelector((state: { notes: NotesState }) => state.notes.attributes);
    const myUuid = useSelector(({ auth }: any) => auth.currentUser.uuid);
    const timeZone = useSelector(({ team }: any) => team.info.home_timezone);
    const teamName = useSelector(({ team }: any) => team.info.display_name);
    const emptyText = totalCount === 0 ? "No notes in this date range." : "No notes match these filters.";

    return (
        <Spin spinning={loading}>
            <div className={twoColumns ? "notes-list-body notes-list-body-2col" : "notes-list-body"}>
                {notes.map((note) => (
                    <NoteCard
                        key={note.uuid}
                        note={note}
                        attributes={attributes}
                        myUuid={myUuid}
                        timeZone={timeZone}
                        teamName={teamName}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        showPlayer={showPlayer}
                    />
                ))}
                {notes.length === 0 && !loading && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />}
            </div>
        </Spin>
    );
};
